import {postMethod} from '~/api'

async function post() {
    return await postMethod('/proxy/cmsAuth')
}

export {post}
